import { Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export const renderTextWithMentions = (text) =>
  text
    ?.split(/((?:@\w+|https?:\/\/(?:www\.)?notebook\.fm\/[^\s]+))/g)
    .map((part, i) => {
      if (part.startsWith("@")) {
        return (
          <Typography
            key={i}
            component={RouterLink}
            to={`/${part.slice(1)}`}
            color="secondary"
            sx={{ cursor: "pointer", textDecoration: "none" }}
          >
            {part}
          </Typography>
        );
      } else if (part.includes("notebook.fm")) {
        return (
          <Typography
            key={i}
            component="a"
            href={part}
            color="secondary"
            sx={{ cursor: "pointer", textDecoration: "none" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part}
          </Typography>
        );
      }
      return (
        <Typography key={i} component="span">
          {part}
        </Typography>
      );
    });
